import { Card, CardBody, Col } from "reactstrap";
import { TooltipFormValidationTitle } from "../../../../../../constants";
import { TooltipFormValidationSubTitle } from "../../../../../../data/formsAndTable/forms/FormControls";
import TooltipFormValidationForm from "./TooltipFormValidationForm";
import CommonCardHeader from "../../../../../../coreComponents/CommonCardHeader";

const TooltipFormValidation = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={TooltipFormValidationTitle} span={TooltipFormValidationSubTitle} />
        <CardBody>
          <TooltipFormValidationForm />
        </CardBody>
      </Card>
    </Col>
  );
};
export default TooltipFormValidation;
